import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'
import { QueryKey } from '@tanstack/react-query'
import { useParams } from 'react-router-dom'
import { getGridAndSystemProtectionSettings } from '../api/get-grid-and-system-protection-settings.api'
import { GridAndSystemProtectionModel } from '../types/grid-and-system-protection.model'
import { useInstallation } from 'src/Libs/flow/installation/hooks'
import { usePortalSuspenseQuery } from 'src/Libs/api'

type UseGridAndSystemProtectionQuery = {
  data: GridAndSystemProtectionModel | null
  isLoading?: boolean
  isError?: boolean
}

export const getGridAndSystemProtectionQueryKey = (storageId: string | null | undefined): QueryKey => [
  'grid-and-system-protection-settings',
  storageId,
]

const useGridAndSystemProtectionQuery = (): UseGridAndSystemProtectionQuery => {
  const { installationId, storageId } = useParams<{ installationId: string; storageId: string }>()
  const authFetch = useAuthFetchWithResponse()

  const installationIdNumber = installationId ? Number.parseInt(installationId) : null
  if (installationIdNumber === null || Number.isNaN(installationIdNumber)) {
    throw new Error('Installation ID is required for simple settings')
  }
  const installation = useInstallation(installationIdNumber)

  const { data, isLoading, isError } = usePortalSuspenseQuery({
    queryKey: getGridAndSystemProtectionQueryKey(storageId),
    queryFn: () => getGridAndSystemProtectionSettings(storageId, authFetch),
  })

  const isDataLoading = isLoading || installation.isLoading
  const hasErrors = isError || installation.isError

  return { data, isLoading: isDataLoading, isError: hasErrors }
}

export default useGridAndSystemProtectionQuery
